import gql from 'graphql-tag'
import { fragPostSummary } from '../fragments/post.js'
import { fragPageInfo } from '../fragments/seo.js'

export const queryPosts = gql`
  ${fragPostSummary}
  ${fragPageInfo}
  query QueryPosts(
    $first: Int = 15
    $endCursor: String
    $where: RootQueryToPostConnectionWhereArgs
  ) {
    posts(after: $endCursor, first: $first, where: $where) {
      edges {
        node {
          ...FragPostSummary
        }
      }
      pageInfo {
        ...FragPageInfo
      }
    }
  }
`
